import type { ReactNode } from 'react';
import { Group, Typography } from '@screentone/core';

import styles from './SiteConfigPage.module.scss';

type SiteConfigPageProps = {
  title: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
};

function SiteConfigPage({ title, actions, children }: SiteConfigPageProps) {
  return (
    <div className={styles.root}>
      <div className={actions ? styles.headerWithActions : styles.header}>
        <Typography variant="header2" margin={{ bottom: 'md' }}>
          {title}
        </Typography>
        {actions ? <Group gap="xs">{actions}</Group> : null}
      </div>
      {children}
    </div>
  );
}

export default SiteConfigPage;
